import { NgModule } from '@angular/core';
import { StamComponent } from './stam.component';



@NgModule({
  declarations: [StamComponent],
  imports: [
  ],
  exports: [StamComponent]
})
export class StamModule { }
